// @ts-nocheck
import {
  ACTIVATE_CONTRACT_FULFILLED,
  FETCH_COMPANIES_FULFILLED,
  FETCH_COMPANIES_REJECTED,
  FETCH_COMPANY_FULFILLED,
  FETCH_COMPANY_REJECTED,
  FETCH_CONTRACT_FULFILLED,
  FETCH_CONTRACT_REJECTED,
  FETCH_PRODUCTS_FULFILLED,
  FETCH_PRODUCTS_REJECTED,
  UPDATE_COMPANY_FULFILLED,
} from './companyActionTypes';

const initialState = {
  companies: null,
  companyDetails: null,
  contractDetails: null,
  companyProducts: null,
};

export default function companyReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMPANIES_FULFILLED:
      return {
        ...state,
        companies: action.payload,
      };
    case FETCH_COMPANIES_REJECTED:
      return {
        ...state,
        companies: null,
      };
    case FETCH_COMPANY_FULFILLED:
      return {
        ...state,
        companyDetails: action.payload,
      };
    case FETCH_COMPANY_REJECTED:
      return {
        ...state,
        companyDetails: null,
      };
    case FETCH_CONTRACT_FULFILLED:
      return {
        ...state,
        contractDetails: action.payload,
      };
    case FETCH_CONTRACT_REJECTED:
      return {
        ...state,
        contractDetails: null,
      };
    case FETCH_PRODUCTS_FULFILLED:
      return {
        ...state,
        companyProducts: action.payload,
      };
    case FETCH_PRODUCTS_REJECTED:
      return {
        ...state,
        companyProducts: null,
      };
    case UPDATE_COMPANY_FULFILLED:
      return {
        ...state,
        companyDetails: action.payload,
      };
    case ACTIVATE_CONTRACT_FULFILLED:
      return {
        ...state,
        contractDetails: action.payload,
      };
    default:
      return state;
  }
}
